import { memo, useMemo } from 'react';

import { type BoardAncestors } from '@air/api/types';
import { Breadcrumbs, type BreadcrumbsItemType } from '@air/component-breadcrumbs';

type BoardSuggestionBreadcrumbsProps = {
  ancestors: BoardAncestors;
};

export const BoardSuggestionBreadcrumbs = memo(({ ancestors }: BoardSuggestionBreadcrumbsProps) => {
  const ancestorsItems = useMemo<BreadcrumbsItemType[]>(() => {
    const items: BreadcrumbsItemType[] = [];

    items.push(
      ...ancestors.map<BreadcrumbsItemType>((ancestor) => ({
        className: 'text-inherit truncate font-normal px-0',
        id: ancestor.id,
        label: ancestor.title,
        type: 'item',
      })),
    );

    return items;
  }, [ancestors]);

  return (
    <Breadcrumbs
      isCompact
      className="overflow-visible ads:text-secondary text-12 text-gray-11"
      items={ancestorsItems}
    />
  );
});

BoardSuggestionBreadcrumbs.displayName = 'BoardSuggestionBreadcrumbs';
